import axios from 'axios';
import { Breadcrumb, Layout, Menu, Image, Row, Col, Button, message, Upload, Card, Modal } from 'antd';
import React, { useEffect, useState, useRef } from 'react';
import JoditEditor from "jodit-react";
const VideoWatchModal = (props) => {
    useEffect(() => {

    })
    return (
        <>
            <Modal
                // width={'auto'}
                style={{ pointerEvents: 'auto' }}
                open={props.open}
                onCancel={e => props.setOpen(false)}
                bodyStyle={{ backgroundColor: '#FFFFFF' }}
                width={1400}
                footer={false}
                className="modalStyle2"
                wrapClassName={"modalStyle2"}
                modalRender={(e) => <>
                    <div style={{ backgroundColor: '#FFFFFF', padding: '10px' }}>
                        <Row gutter={[8, 16]} justify={'center'}>
                            <Col span={22} style={{ overflowX: 'scroll' }}>
                                <span dangerouslySetInnerHTML={{ __html: props.editcard.youtube_iframe }}></span>
                            </Col>
                            <Col span={22} style={{ fontSize: '2rem', fontWeight: 500 }}>
                                {props.editcard.title}
                            </Col>
                            <Col span={22} style={{ fontSize: '1rem' }}>
                                {props.editcard.content}
                            </Col>
                        </Row>
                    </div>
                </>}
            ></Modal>
        </>
    )
}
export default VideoWatchModal;